// 쪽 그림 위에서 푸는 섹션(리더스북 전자책)인가. 이 섹션은 바깥 머리줄을 걷고 화면 전체를 책에 준다.
// 노트북에서 머리줄 · 좁은 본문 폭 때문에 쪽이 너무 작았다(2026-10-18 대표). 나가기는 책 안에 있다.
// 원서 · 내용이해 워크북은 쪽 그림이 아니라 지인에듀가 주는 글로 그린다(BookWorkbookPage, 10/18 대표).
export const isBookScreenSection = (section) => Boolean(section) && section.type === "ebook";
